import React from 'react';
import { Search, ListFilter } from 'lucide-react';
import { FilterAssessedType } from '../../hooks/usePlayerFiltering';

interface PlayerFiltersProps {
  nameSearch: string;
  setNameSearch: (value: string) => void;
  positionFilter: string;
  setPositionFilter: (value: string) => void;
  filterAssessed: FilterAssessedType;
  setFilterAssessed: (value: FilterAssessedType) => void;
}

const PlayerFilters: React.FC<PlayerFiltersProps> = ({
  nameSearch,
  setNameSearch,
  positionFilter,
  setPositionFilter,
  filterAssessed,
  setFilterAssessed
}) => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold flex items-center mb-2">
          Players
        </h2>
        <div className="flex flex-wrap gap-2 mb-2">
          <select
            value={positionFilter}
            onChange={(e) => setPositionFilter(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg"
          >
            <option value="">All Positions</option>
            <option value="Goalkeeper">Goalkeeper</option>
            <option value="Defender">Defender</option>
            <option value="Midfielder">Midfielder</option>
            <option value="Forward">Forward</option>
          </select>
          <select
            value={filterAssessed}
            onChange={(e) => setFilterAssessed(e.target.value as FilterAssessedType)}
            className="px-3 py-2 border border-gray-300 rounded-lg"
          >
            <option value="all">All Players</option>
            <option value="assessed">Assessed by Anyone</option>
            <option value="unassessed">Not Assessed</option>
            <option value="assessed-by-me">Assessed by Me</option>
            <option value="not-assessed-by-me">Not Assessed by Me</option>
          </select>
        </div>
      </div>

      <div className="relative">
        <Search className="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={nameSearch}
          onChange={(e) => setNameSearch(e.target.value)}
          placeholder="Search players..."
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>
  );
};

export default PlayerFilters;
